import React from 'react';

import { CommonPropTypes } from '../Icons.types';

const Tick: React.FC<CommonPropTypes> = ({ className }) => {
  return (
    <svg
      className={className}
      width='34'
      height='25'
      viewBox='0 0 34 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M33.1055 1.39453C33.7734 2.13672 33.7734 3.25 33.1055 3.91797L13.5117 23.5117C12.7695 24.2539 11.6562 24.2539 10.9883 23.5117L0.894531 13.418C0.152344 12.75 0.152344 11.6367 0.894531 10.9688C1.5625 10.2266 2.67578 10.2266 3.34375 10.9688L12.1758 19.8008L30.582 1.39453C31.25 0.726562 32.3633 0.726562 33.0312 1.39453H33.1055Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default Tick;
